<template>
	<div class="d-md-flex align-items-center justify-content-between gap-4 mt-2 mb-4">
		<div>
			<h2 class="main-title fs-28 mb-0" style="display: inline;">Rowdy Sheeters Statistics</h2>
		</div>
		<div>
			<label class="form-label">&nbsp;</label>
			<div class="d-flex align-items-between">
				<button class="btn btn-outline-primary form-control mx-2" @click="clearSearch()">Clear</button>
				<button v-can="'download.reports'" class="btn btn-outline-success form-control mx-2"
					@click="downloadExcel()">Download</button>
			</div>
		</div>
	</div>
	<div class="row g-3">
		<div class="col-xl-12">
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-3 mb-3">
							<label class="form-label">Sub Division</label>
							<select class="form-control border-0 border-bottom form-select"
								@change="getCircles(); getGroupByPoliceStations();"
								:class="{ 'is-invalid': errors?.sub_division_id }" v-model="sub_division_id">
								<option value="">Select Sub Division</option>
								<option v-for="sub_division, key in sub_divisions"
									:value="sub_division.sub_division_id">{{ sub_division.sub_division }}</option>
							</select>
							<span v-if="errors?.sub_division_id" class="invalid-feedback">{{
								errors?.sub_division_id[0] }}</span>
						</div>
						<div class="col-3 mb-3">
							<label class="form-label">Circles</label>
							<select class="form-control border-0 border-bottom form-select"
								@change="getGroupByPoliceStations()"
								:class="{ 'is-invalid': errors?.circle_id }" v-model="circle_id"
								:disabled="!sub_division_id">
								<option value="">Select Circle</option>
								<option v-for="c, key in circles" :value="c.circle_id">{{ c.circle }}</option>
							</select>
							<span v-if="errors?.circle_id" class="invalid-feedback">{{ errors?.circle_id[0] }}</span>
						</div>
						<div class="col-3 mb-3">
							<label class="form-label">&nbsp;</label>
							<div class="form-check mt-2">
								<input class="form-check-input" type="radio" value="all_sub_division" v-model="all_data"
									@change="getAllInformation()" />
								<label class="form-check-label" for=""> All Sub Divisions </label>
							</div>
						</div>
						<div class="col-3 mb-3">
							<label class="form-label">&nbsp;</label>
							<div class="form-check mt-2">
								<input class="form-check-input" type="radio" value="all_police_station"
									v-model="all_data" @change="getAllInformation()" />
								<label class="form-check-label" for=""> All Police Stations </label>
							</div>
						</div>
					</div>
					<div class="table-responsive small" style="overflow-y:scroll; height: 60vh;">
						<table class="table table-hover table-sm table-striped table-bordered" v-if="tab.sub_division">
							<thead class="freeze-head">
								<tr>
									<th>S.L. No</th>
									<th>Sub Division</th>
									<!-- <th class="text-center">Rowdy Sheeter</th> -->
									<th class="text-center">Rowdy Sheeter<br>By PS</th>
									<th class="text-center">Category<br>A</th>
									<th class="text-center">Category<br>B</th>
									<th class="text-center">Category<br>C</th>
									<th class="text-center">Present</th>
									<th class="text-center">&nbsp;&nbsp;OV&nbsp;&nbsp;</th>
									<th class="text-center">&nbsp;&nbsp;JC&nbsp;&nbsp;</th>
									<th class="text-center">Active</th>
									<th class="text-center">InActive</th>
									<th class="text-center">Closed</th>
									<th class="text-center">Rowdy<br>Other Closed</th>
									<th class="text-center">Total<br>Rowdy Sheeter By PS</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="val, key in group_by_sub_division_data" :key="key">
									<td class="text-center">{{ key + 1 }}</td>
									<td>{{ val.sub_division?.sub_division || '' }}</td>
									<!-- <td class="text-center">{{ val.rowdy_counts }}</td> -->
									<td class="text-center">{{ val.total_counts - (val.closed_counts + val.rowdy_other_closed) }}</td>
									<td class="text-center">{{ val.a_counts }}</td>
									<td class="text-center">{{ val.b_counts }}</td>
									<td class="text-center">{{ val.c_counts }}</td>
									<td class="text-center">{{ val.present_counts }}</td>
									<td class="text-center">{{ val.ov_counts }}</td>
									<td class="text-center">{{ val.jc_counts }}</td>
									<td class="text-center">{{ val.active_counts }}</td>
									<td class="text-center">{{ val.inactive_counts }}</td>
									<td class="text-center">{{ val.closed_counts }}</td>
									<td class="text-center">{{ val.rowdy_other_closed }}</td>
									<td class="text-center">{{ val.total_counts }}</td>
								</tr>
								<tr class="text-center fw-bold">
									<td colspan="2">TOTAL</td>
									<!-- <td>{{ totals.rowdy_counts }}</td> -->
									<td>{{ totals.total_counts - (totals.closed_counts + totals.rowdy_other_closed)}}</td>
									<td>{{ totals.a_counts }}</td>
									<td>{{ totals.b_counts }}</td>
									<td>{{ totals.c_counts }}</td>
									<td>{{ totals.present_counts }}</td>
									<td>{{ totals.ov_counts }}</td>
									<td>{{ totals.jc_counts }}</td>
									<td>{{ totals.active_counts }}</td>
									<td>{{ totals.inactive_counts }}</td>
									<td>{{ totals.closed_counts }}</td>
									<td>{{ totals.rowdy_other_closed }}</td>
									<td>{{ totals.total_counts }}</td>
								</tr>
								<!-- <tr class="small" v-if="rowdies_with_incidents > 0">
									<td colspan="11"><span class="text-primary"><i>Note: - Total rowdy sheeters with
												category: {{ rowdies_with_incidents }}</i></span></td>
								</tr> -->
							</tbody>
						</table>
						<table class="table table-hover table-sm table-striped table-bordered"
							v-if="tab.police_station">
							<thead class="freeze-head">
								<tr>
									<th>S.L. No</th>
									<th>Police Station</th>
									<!-- <th class="text-center">Rowdy Sheeter</th> -->
									<th class="text-center">Rowdy Sheeter<br>By PS</th>
									<th class="text-center">Category<br>A</th>
									<th class="text-center">Category<br>B</th>
									<th class="text-center">Category<br>C</th>
									<th class="text-center">Present</th>
									<th class="text-center">&nbsp;&nbsp;OV&nbsp;&nbsp;</th>
									<th class="text-center">&nbsp;&nbsp;JC&nbsp;&nbsp;</th>
									<th class="text-center">Active</th>
									<th class="text-center">InActive</th>
									<th class="text-center">Closed</th>
									<th class="text-center">Rowdy<br>Other Closed</th>
									<th class="text-center">Total<br>Rowdy Sheeter By PS</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="val, key in group_by_police_station_data" :key="key">
									<td class="text-center">{{ key + 1 }}</td>
									<td>{{ val.police_station }}</td>
									<!-- <td class="text-center">{{ val.rowdy_counts }}</td> -->
									<td class="text-center">{{ val.total_counts - (val.closed_counts + val.rowdy_other_closed) }}</td>
									<td class="text-center">{{ val.a_counts }}</td>
									<td class="text-center">{{ val.b_counts }}</td>
									<td class="text-center">{{ val.c_counts }}</td>
									<td class="text-center">{{ val.present_counts }}</td>
									<td class="text-center">{{ val.ov_counts }}</td>
									<td class="text-center">{{ val.jc_counts }}</td>
									<td class="text-center">{{ val.active_counts }}</td>
									<td class="text-center">{{ val.inactive_counts }}</td>
									<td class="text-center">{{ val.closed_counts }}</td>
									<td class="text-center">{{ val.rowdy_other_closed }}</td>
									<td class="text-center">{{ val.total_counts }}</td>
								</tr>
								<tr class="text-center fw-bold">
									<td colspan="2">TOTAL</td>
									<!-- <td>{{ totals.total_counts }}</td> -->
									<td>{{ totals.total_counts - (totals.closed_counts + totals.rowdy_other_closed) }}</td>
									<td>{{ totals.a_counts }}</td>
									<td>{{ totals.b_counts }}</td>
									<td>{{ totals.c_counts }}</td>
									<td>{{ totals.present_counts }}</td>
									<td>{{ totals.ov_counts }}</td>
									<td>{{ totals.jc_counts }}</td>
									<td>{{ totals.active_counts }}</td>
									<td>{{ totals.inactive_counts }}</td>
									<td>{{ totals.closed_counts }}</td>
									<td>{{ totals.rowdy_other_closed }}</td>
									<td>{{ totals.total_counts }}</td>
								</tr>
								<!-- <tr class="small" v-if="rowdies_with_incidents > 0">
									<td colspan="11"><span class="text-primary"><i>Note: - Total rowdy sheeters with
												category: {{ rowdies_with_incidents }}</i></span></td>
								</tr> -->
							</tbody>
						</table>
						<table class="table table-hover table-sm table-striped table-bordered"
							v-if="tab.all_sub_divisions">
							<thead class="freeze-head">
								<tr>
									<th colspan="13" class="text-center text-primary">ALL SUB DIVISIONS</th>
								</tr>
								<tr>
									<th>S.L. No</th>
									<th>Sub Division</th>
									<!-- <th class="text-center">Rowdy Sheeter</th> -->
									<th class="text-center">Rowdy Sheeter<br>By PS</th>
									<th class="text-center">Category<br>A</th>
									<th class="text-center">Category<br>B</th>
									<th class="text-center">Category<br>C</th>
									<th class="text-center">Present</th>
									<th class="text-center">&nbsp;&nbsp;OV&nbsp;&nbsp;</th>
									<th class="text-center">&nbsp;&nbsp;JC&nbsp;&nbsp;</th>
									<th class="text-center">Active</th>
									<th class="text-center">InActive</th>
									<th class="text-center">Closed</th>
									<th class="text-center">Rowdy<br>Other Closed</th>
									<th class="text-center">Total<br>Rowdy Sheeter By PS</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="val, key in all_sub_division_wise" :key="key">
									<td class="text-center">{{ key + 1 }}</td>
									<td>{{ val.sub_division?.sub_division || '' }}</td>
									<!-- <td class="text-center">{{ val.rowdy_counts }}</td> -->
									<td class="text-center">{{ val.total_counts - (val.closed_counts + val.rowdy_other_closed)}}</td>
									<td class="text-center">{{ val.a_counts }}</td>
									<td class="text-center">{{ val.b_counts }}</td>
									<td class="text-center">{{ val.c_counts }}</td>
									<td class="text-center">{{ val.present_counts }}</td>
									<td class="text-center">{{ val.ov_counts }}</td>
									<td class="text-center">{{ val.jc_counts }}</td>
									<td class="text-center">{{ val.active_counts }}</td>
									<td class="text-center">{{ val.inactive_counts }}</td>
									<td class="text-center">{{ val.closed_counts }}</td>
									<td class="text-center">{{ val.rowdy_other_closed }}</td>
									<td class="text-center">{{ val.total_counts }}</td>
								</tr>
								<tr class="text-center fw-bold">
									<td colspan="2">TOTAL</td>
									<!-- <td>{{ totals.rowdy_counts }}</td> -->
									<td>{{ totals.total_counts - (totals.closed_counts + totals.rowdy_other_closed) }}</td>
									<td>{{ totals.a_counts }}</td>
									<td>{{ totals.b_counts }}</td>
									<td>{{ totals.c_counts }}</td>
									<td>{{ totals.present_counts }}</td>
									<td>{{ totals.ov_counts }}</td>
									<td>{{ totals.jc_counts }}</td>
									<td>{{ totals.active_counts }}</td>
									<td>{{ totals.inactive_counts }}</td>
									<td>{{ totals.closed_counts }}</td>
									<td>{{ totals.rowdy_other_closed }}</td>
									<td>{{ totals.total_counts }}</td>
								</tr>
								<!-- <tr class="small" v-if="rowdies_with_incidents > 0">
									<td colspan="11"><span class="text-primary"><i>Note: - Total rowdy sheeters with
												category: {{ rowdies_with_incidents }}</i></span></td>
								</tr> -->
							</tbody>
						</table>
						<table class="table table-hover table-sm table-striped table-bordered"
							v-if="tab.all_police_stations">
							<thead class="freeze-head">
								<tr>
									<th colspan="13" class="text-center text-primary">ALL POLICE STATIONS</th>
								</tr>
								<tr>
									<th>S.L. No</th>
									<th>Police Station</th>
									<!-- <th class="text-center">Rowdy Sheeter</th> -->
									<th class="text-center">Rowdy Sheeter<br>By PS</th>
									<th class="text-center">Category<br>A</th>
									<th class="text-center">Category<br>B</th>
									<th class="text-center">Category<br>C</th>
									<th class="text-center">Present</th>
									<th class="text-center">&nbsp;&nbsp;OV&nbsp;&nbsp;</th>
									<th class="text-center">&nbsp;&nbsp;JC&nbsp;&nbsp;</th>
									<th class="text-center">Active</th>
									<th class="text-center">InActive</th>
									<th class="text-center">Closed</th>
									<th class="text-center">Rowdy<br>Other Closed</th>
									<th class="text-center">Total<br>Rowdy Sheeter By PS</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="val, key in all_police_station_wise" :key="key">
									<td class="text-center">{{ key + 1 }}</td>
									<td>{{ val.police_station }}</td>
									<!-- <td class="text-center">{{ val.rowdy_counts }}</td> -->
									<td class="text-center">{{ val.total_counts - (val.closed_counts + val.rowdy_other_closed) }}</td>
									<td class="text-center">{{ val.a_counts }}</td>
									<td class="text-center">{{ val.b_counts }}</td>
									<td class="text-center">{{ val.c_counts }}</td>
									<td class="text-center">{{ val.present_counts }}</td>
									<td class="text-center">{{ val.ov_counts }}</td>
									<td class="text-center">{{ val.jc_counts }}</td>
									<td class="text-center">{{ val.active_counts }}</td>
									<td class="text-center">{{ val.inactive_counts }}</td>
									<td class="text-center">{{ val.closed_counts }}</td>
									<td class="text-center">{{ val.rowdy_other_closed }}</td>
									<td class="text-center">{{ val.total_counts }}</td>
								</tr>
								<tr class="text-center fw-bold">
									<td colspan="2">TOTAL</td>
									<!-- <td>{{ totals.rowdy_counts }}</td> -->
									<td>{{ totals.total_counts - (totals.closed_counts + totals.rowdy_other_closed) }}</td>
									<td>{{ totals.a_counts }}</td>
									<td>{{ totals.b_counts }}</td>
									<td>{{ totals.c_counts }}</td>
									<td>{{ totals.present_counts }}</td>
									<td>{{ totals.ov_counts }}</td>
									<td>{{ totals.jc_counts }}</td>
									<td>{{ totals.active_counts }}</td>
									<td>{{ totals.inactive_counts }}</td>
									<td>{{ totals.closed_counts }}</td>
									<td>{{ totals.rowdy_other_closed }}</td>
									<td>{{ totals.total_counts }}</td>
								</tr>
								<!-- <tr class="small" v-if="rowdies_with_incidents > 0">
									<td colspan="11"><span class="text-primary"><i>Note: - Total rowdy sheeters with
												category: {{ rowdies_with_incidents }}</i></span></td>
								</tr> -->
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
	data() {
		return {
			sub_division_id: '',
			circle_id: '',
			police_station_id: '',
			sub_divisions: [],
			circles: [],
			police_stations: [],
			group_by_sub_division_data: [],
			group_by_police_station_data: [],
			all_sub_division_wise: [],
			all_police_station_wise: [],
			errors: [],
			totals: {
				a_counts: 0,
				b_counts: 0,
				c_counts: 0,
				rowdy_counts: 0,
				total_counts: 0,
				present_counts: 0,
				ov_counts: 0,
				jc_counts: 0,
				active_counts: 0,
				inactive_counts: 0,
				closed_counts: 0,
				rowdy_other_closed: 0,
			},
			tab: {
				sub_division: true,
				police_station: false,
				all_sub_divisions: false,
				all_police_stations: false
			},
			all_data: '',
			rowdies_with_incidents: 0,
		}
	},

	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.getSubDivisions();
			vm.getGroupBySubDivisions();
		})
	},

	watch: {
		sub_division_id(val) {
			if (val != '') {
				this.setTab('police_station');
			}
		},

		all_data(val) {
			if (val == 'all_sub_division') {
				this.tab.sub_division = false;
				this.tab.police_station = false;
				this.tab.all_sub_divisions = true;
				this.tab.all_police_stations = false;
			}
		}
	},
	methods: {
		getSubDivisions() {
			this.sub_division_id = '';
			this.circle_id = '';
			this.police_station_id = '';
			let vm = this;
			let loader = this.$loading.show();
			this.$store.dispatch('post', { uri: 'getSubDivisions', data: {} })
				.then(response => {
					loader.hide();
					this.sub_divisions = response.data.data || [];
					this.getGroupBySubDivisions();
				})
				.catch(error => {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch('error', error.response?.data?.message || 'Request failed');
				})
		},

		getCircles() {
			this.circle_id = '';
			if (!this.sub_division_id) {
				this.circles = [];
				return;
			}
			this.$store.dispatch('post', { uri: 'getCircles', data: { sub_division_id: this.sub_division_id } })
				.then(response => {
					this.circles = response.data.data || response.data || [];
				})
				.catch(() => {
					this.circles = [];
				})
		},

		getGroupBySubDivisions() {
			this.errors = [];
			let vm = this;
			let loader = this.$loading.show();
			this.$store.dispatch('post', { uri: 'getGroupBySubDivisions', data: {} })
				.then(response => {
					loader.hide();
					this.group_by_sub_division_data = response.data.data || [];
					this.rowdies_with_incidents = response.data.rowdies_with_incidents || 0;
					this.calculateTotal(this.group_by_sub_division_data);
					this.setTab('sub_division');
				})
				.catch(error => {
					loader.hide();
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch('error', error.response?.data?.message || 'Request failed');
				})
		},

		getGroupByPoliceStations() {
			if (this.sub_division_id == '') {
				this.getGroupBySubDivisions();
				this.setTab('sub_division');
				return;
			}
			this.errors = [];
			let vm = this;
			let loader = this.$loading.show();
			this.$store.dispatch('post', { uri: 'getGroupByPoliceStations', data: { sub_division_id: this.sub_division_id, circle_id: this.circle_id || undefined } })
				.then(response => {
					loader.hide();
					this.group_by_police_station_data = response.data.data;
					this.rowdies_with_incidents = response.data.rowdies_with_incidents;
					this.calculateTotal(this.group_by_police_station_data);
				})
				.catch(error => {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch('error', error.response.data.message);
				})
		},
		clearSearch() {
			this.sub_division_id = '';
			this.circle_id = '';
			this.police_station_id = '';
			this.all_data = '';
			this.getGroupBySubDivisions();
			this.setTab('sub_division');
		},

		downloadExcel() {
			let params = {};
			let endPoint = '';
			if (this.tab.sub_division) {
				endPoint = 'groupBySubDivision';
			} else if (this.tab.police_station) {
				// window.open(this.$store.getters.downloadUrl + "groupByPoliceStation?sub_division_id=" + this.sub_division_id);
				endPoint = 'groupByPoliceStation';
				params.sub_division_id = this.sub_division_id;
			} else if (this.tab.all_sub_divisions) {
				// window.open(this.$store.getters.downloadUrl + "groupByAllSubDivision");
				endPoint = 'groupByAllSubDivision';
			} else if (this.tab.all_police_stations) {
				// window.open(this.$store.getters.downloadUrl + "groupByAllPoliceStation");
				endPoint = 'groupByAllPoliceStation';
			}

			let loader = this.$loading.show();
			const downloadExcelWithAuth = async () => {
				try {
					// axios.defaults.withCredentials = true;
					const response = await axios.post(this.$store.getters.downloadUrl + 'api/' + endPoint,
						params,
						{
							responseType: 'blob',
							headers: {
								Authorization: 'Bearer ' + this.$store.getters.token
							}
						}
					);
					const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = 'rowdy_sheeter_statistics.xlsx';
					link.click();
					URL.revokeObjectURL(link.href);
					loader.hide();
				} catch (error) {
					loader.hide();
					console.error('Error downloading the excel:', error);
					alert('There was an issue downloading the excel.');
				}
			};
			downloadExcelWithAuth();
		},

		calculateTotal(data) {
			this.totals.a_counts = 0;
			this.totals.b_counts = 0;
			this.totals.c_counts = 0;
			this.totals.total_counts = 0;
			this.totals.rowdy_counts = 0;
			this.totals.present_counts = 0;
			this.totals.ov_counts = 0;
			this.totals.jc_counts = 0;
			this.totals.active_counts = 0;
			this.totals.inactive_counts = 0;
			this.totals.closed_counts = 0;
			this.totals.rowdy_other_closed = 0;
			data.forEach(ele => {
				this.totals.a_counts += ele.a_counts;
				this.totals.b_counts += ele.b_counts;
				this.totals.c_counts += ele.c_counts;
				this.totals.rowdy_counts += ele.rowdy_counts;
				this.totals.total_counts += ele.total_counts;
				this.totals.present_counts += ele.present_counts;
				this.totals.ov_counts += ele.ov_counts;
				this.totals.jc_counts += ele.jc_counts;
				this.totals.active_counts += ele.active_counts;
				this.totals.inactive_counts += ele.inactive_counts;
				this.totals.closed_counts += ele.closed_counts;
				this.totals.rowdy_other_closed += ele.rowdy_other_closed;
			})
		},

		getAllInformation() {
			if (this.all_data == 'all_sub_division') {
				this.getAllSubDivisionWise();
			} else {
				this.getAllPoliceStationWise();
			}
		},
		getAllSubDivisionWise() {
			let vm = this;
			let loader = this.$loading.show();
			this.$store.dispatch('post', { uri: 'getAllSubDivisionWise' })
				.then(response => {
					loader.hide();
					this.all_sub_division_wise = response.data.data;
					this.rowdies_with_incidents = response.data.rowdies_with_incidents;
					this.calculateTotal(this.all_sub_division_wise);
					this.setTab('all_sub_divisions');
				})
				.catch(error => {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch('error', error.response.data.message);
				})
		},
		getAllPoliceStationWise() {
			let vm = this;
			let loader = this.$loading.show();
			this.$store.dispatch('post', { uri: 'getAllPoliceStationWise' })
				.then(response => {
					loader.hide();
					this.all_police_station_wise = response.data.data;
					this.rowdies_with_incidents = response.data.rowdies_with_incidents;
					this.calculateTotal(this.all_police_station_wise);
					this.setTab('all_police_stations');
				})
				.catch(error => {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch('error', error.response.data.message);
				})
		},
		setTab(tab) {
			this.tab.sub_division = false;
			this.tab.police_station = false;
			this.tab.all_sub_divisions = false;
			this.tab.all_police_stations = false;

			switch (tab) {
				case 'sub_division':
					this.tab.sub_division = true;
					break;
				case 'police_station':
					this.tab.police_station = true;
					break;
				case 'all_sub_divisions':
					this.tab.all_sub_divisions = true;
					break;
				case 'all_police_stations':
					this.tab.all_police_stations = true;
					break;
				default:
					break;
			}
		}
	}
}
</script>

<style scoped>
thead {
	top: -17px !important;
	z-index: 5 !important;
	background-color: #f3f5f9
}
</style>